import axios from 'axios';
import { SERVER_URL } from 'Constants';
import { buildUrl } from 'Util/FetchUtils';

export const EMAIL_TEMPLATE_API_URL = `${SERVER_URL}/api/entity/EmailTemplateEntity`;

export async function getContactUsEmailAddress() {
	return axios.get(buildUrl(`${EMAIL_TEMPLATE_API_URL}/contact-us-email-address`)).then(x => x.data as string);
}
